import { useEffect } from 'react';

import LoadingProgress from '../../layout/LoadingProgress';
import { useUnawaitedNavigate } from '../../utils/react-router';
import { unawaited } from '../../utils/promise';
import { getRedirectUri, isServiceCloudRedirectUri } from '../../utils/redirect-uri';
import NotFoundComponent from '../not-found';
import { useAccessToken } from '../../auth/providers/AccessTokenContext';
import { useQuery } from '../../routes';

export const CallbackPage = () => {
  const accessToken = useAccessToken();
  const navigate = useUnawaitedNavigate();
  const overrideRedirectUri = useQuery().get('redirect_uri');

  useEffect(() => {
    const handleCallback = async () => {
      if (accessToken.status === 'idle') {
        return unawaited(accessToken.signIn());
      }

      if (accessToken.status !== 'signedIn') {
        return () => {};
      }

      const storedRedirectUri = getRedirectUri();
      const redirectUri = isServiceCloudRedirectUri(storedRedirectUri)
        ? storedRedirectUri
        : overrideRedirectUri || storedRedirectUri;
      if (typeof redirectUri === 'string') {
        if (redirectUri.startsWith(window.location.origin) || redirectUri.startsWith('http')) {
          window.location.href = redirectUri;
          return () => {};
        }
        return navigate(redirectUri, { replace: true });
      }
      return navigate('/', { replace: true });
    };
    handleCallback();
  }, [accessToken, navigate, overrideRedirectUri]);

  if (accessToken.status === 'error') {
    return <NotFoundComponent />;
  }
  return <LoadingProgress />;
};
